export const selectContactInvites = state => state.contacts.contactInvites;
export const selectReceivedContactInvites = state =>
  state.contacts.contactInvites.received;
export const selectSentContactInvites = state =>
  state.contacts.contactInvites.sent;



// WEBPACK FOOTER //
// ./src/redux/selectors/contacts.selectors.js